import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import ServiceTag, {
  TagGroup,
  SKINS,
  ServiceTagFTC,
  ServiceTagFleetService,
} from 'components/ServiceTag';
import { IS_TENANT } from 'tenant/config';

const DriverInfoCell = ({ isDedicated, isFleetService, isFTC, isUnsuitable, intl }) => {
  const t = intl.messages.modules.journey.card.driver_info;
  return (
    <TagGroup>
      {isDedicated && !IS_TENANT && (
        <ServiceTag text={t.dedicated} skin={SKINS.grey} weight="bold" textTransform="Uppercase" />
      )}
      {isFleetService && !IS_TENANT && <ServiceTagFleetService />}
      {isFTC && !IS_TENANT && <ServiceTagFTC />}
      {isUnsuitable && !IS_TENANT && (
        <ServiceTag
          text={t.unsuitable}
          skin={SKINS.error}
          weight="bold"
          textTransform="Uppercase"
        />
      )}
    </TagGroup>
  );
};

DriverInfoCell.propTypes = {
  className: PropTypes.string,
  isDedicated: PropTypes.bool.isRequired,
  isFleetService: PropTypes.bool.isRequired,
  isFTC: PropTypes.bool.isRequired,
  isUnsuitable: PropTypes.bool.isRequired,
};

export default injectIntl(DriverInfoCell);
